import { minifyRecords, table } from './Airtable';

export const fetchTable = async () => {
	try {
		const records = await table.select().all();
		const minifiedRecords = minifyRecords(records);
		return {
			body: minifiedRecords,
		};
	} catch (e) {
		return {
			error: `Error: ${e}`,
			body: [],
		};
	}
};
